/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The supplied samples let you inspect a finished workbook and make reversible edits. Use the small workshop example for a second exercise, then try an independent copy of a file you understand. Keep the learning session separate from the original file you depend on for real work.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。现成示例能让你查看完整工作簿并尝试可撤销修改。再用小型工作坊示例练习一次，之后才试用你熟悉文件的独立副本。学习过程应与实际工作所依赖的原件分开。`)
};

/**
* | output |
* | --- |
* | "Yes. The supplied samples let you inspect a finished workbook and make reversible edits. Use the small workshop example for a second exercise, then try an in..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_3_answer as "gc.search_guides.what_is_gridcraft.sections.8.questions.3.answer" }